import { IUser } from 'modules/core/types';

type InventoryUser = Pick<IUser, 'isWithInventory' | 'withWholesaleInventory' | 'foureyesWebsiteId'> | null | undefined;

/**
 * True when the dealer has inventory that vehicle search can use: owned
 * inventory, wholesale inventory, or FourEyes-imported inventory.
 *
 * FourEyes SSO users arrive with `with_inventory=false` even after vehicles are
 * imported, so UI that only checks isWithInventory / withWholesaleInventory
 * incorrectly treats them as the no-inventory demo experience (ticket 7979).
 */
export const userHasInventory = (user: InventoryUser): boolean =>
  Boolean(user?.isWithInventory || user?.withWholesaleInventory || user?.foureyesWebsiteId);
